import { useRoute } from 'vue-router'

export function useShare() {
  const route = useRoute()

  const getFullUrl = () => {
    const origin = window.location.origin
    const path = route.fullPath
    return `${origin}${path}`
  }

  const share = (platform: string, title: string) => {
    const url = getFullUrl()
    const text = title
    let shareUrl = ''

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`
        break
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
        break
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
        break
      case 'telegram':
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`
        break
      case 'link':
        navigator.clipboard.writeText(url)
        return
    }

    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return {
    share,
  }
}
